import React from "react";
import { Link } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaBehance,
  FaPhone,
  FaFax,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { useSelector } from "react-redux";

const commentNetworksIcons = {
  facebook: <FaFacebookF />,
  linkedin: <FaLinkedinIn />,
  behance: <FaBehance />,
  twitter: <FaXTwitter />,
};

const OffcanvasMenu = ({ offcanvasShow, offcanvasHide }) => {
  const { currentCustomer } = useSelector((state) => state.store);
  const [isAvailable, setIsAvailable] = React.useState(false);

  React.useEffect(() => {
    const checkAvailability = () => {
      // get current day if is weekend return false
      const nowForCustomer = new Date().toLocaleString("en-US", {
        timeZone: currentCustomer?.timeZone || "America/Caracas",
      });

      const day = nowForCustomer;
      if (day === 0 || day === 6) {
        setIsAvailable(false);
        return;
      }
      // get time from nowForCustomer
      const time = new Date(nowForCustomer).getHours();
      if (time >= 8 && time < 16) {
        setIsAvailable(true);
      }
    };
    checkAvailability();
  }, [currentCustomer]);
  return (
    <Offcanvas
      show={offcanvasShow}
      onHide={offcanvasHide}
      placement="end"
      className="header-offcanvasmenu"
    >
      <Offcanvas.Header closeButton></Offcanvas.Header>
      <Offcanvas.Body>
        <form action="#" className="side-nav-search-form">
          <div className="form-group">
            <input
              type="text"
              className="search-field"
              name="search-field"
              placeholder="Buscar..."
            />
            <button className="side-nav-search-btn">
              <i className="fas fa-search"></i>
            </button>
          </div>
        </form>
        <div className="row ">
          <div className="col-lg-5 col-xl-6">
            <ul className="main-navigation list-unstyled">
              <li>
                <Link to={"#"}>Soporte</Link>
              </li>
              <li>
                <Link to={"#"}>Guías y Tutoriales</Link>
              </li>
              <li>
                <Link to={"#"}>Municipalidad</Link>
              </li>
            </ul>
          </div>
          <div className="col-lg-7 col-xl-6">
            <div className="contact-info-wrap">
              <div className="contact-inner">
                <address className="address">
                  <span className="title">Contacto</span>
                  {currentCustomer?.address ? (
                    <p>{currentCustomer?.address}</p>
                  ) : (
                    <p>Gestión Ciudad, Caracas, Venezuela.</p>
                  )}
                </address>
                <address className="address">
                  <span className="title">
                    {/* if time is 08AM 04PM America/Caracas time zone L-V  show estamos disponibles else offline */}
                    {isAvailable
                      ? "Estamos disponibles. Llame ahora."
                      : "Estamos fuera de línea."}
                  </span>
                  <a href="tel:8884562790" className="tel">
                    <FaPhone /> {currentCustomer?.phone || "(212) 000-0000"}
                  </a>
                  {/* <a href="tel:12125553333" className="tel">
                    <FaFax /> {currentCustomer.fax || "(416) 000-0000"}
                  </a> */}
                </address>
              </div>
              {currentCustomer?.apps_config?.socialNetworks && (
                <div className="contact-inner">
                  <h5 className="title">Encuéntranos aquí</h5>
                  <div className="contact-social-share">
                    <ul className="social-share list-unstyled">
                      {currentCustomer?.apps_config.socialNetworks.map(
                        (network) => (
                          <li key={network.name}>
                            <a href={network.url}>
                              {network.image ? (
                                <img
                                  src={network.image}
                                  alt={network.name}
                                  width={24}
                                  height={24}
                                />
                              ) : (
                                Object.keys(commentNetworksIcons).includes(
                                  network.name
                                ) && commentNetworksIcons[network.name]
                              )}
                            </a>
                          </li>
                        )
                      )}
                      {/* <li>
                      <a href="https://facebook.com/">
                        <FaFacebookF />
                      </a>
                    </li>

                    <li>
                      <a href="https://twitter.com/">
                        <FaXTwitter />
                      </a>
                    </li> */}
                      {/* <li>
                      <a href="https://www.behance.net/">
                        <FaBehance />
                      </a>
                    </li> */}
                      {/* <li>
                      <a href="https://www.linkedin.com/">
                        <FaLinkedinIn />
                      </a>
                    </li> */}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default OffcanvasMenu;
